export const amplifyConfig = {
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    region: process.env.REACT_APP_AWSREGION,
    userPoolId: process.env.REACT_APP_USERPOOLID,
    userPoolWebClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,
  },
  API: {
    endpoints:[
      {
        name:'PredictApi',
        region: process.env.REACT_APP_PREDICTAPIREGION,
        endpoint: process.env.REACT_APP_PREDICTAPI
      },
      {
        name:'PredictSubdivApi',
        region: process.env.REACT_APP_PREDICTSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_PREDICTSUBDIVAPI
      },
      {
        name:'GetResultSubdivApi',
        region: process.env.REACT_APP_GETRESULTSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_GETRESULTSUBDIVAPI
      },
      {
        name:'CutoutApi',
        region: process.env.REACT_APP_CUTOUTAPIREGION,
        endpoint: process.env.REACT_APP_CUTOUTAPI
      },
      {
        name:'CutoutSubdivApi',
        region: process.env.REACT_APP_CUTOUTSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_CUTOUTSUBDIVAPI
      },
      {
        name:'CutoutObsrecApi',
        region: process.env.REACT_APP_CUTOUTOBSRECAPIREGION,
        endpoint: process.env.REACT_APP_CUTOUTOBSRECAPI
      },
      {
        name:'KansatsuKirokuApi',
        region: process.env.REACT_APP_KANSATSUKIROKUAPIREGION,
        endpoint: process.env.REACT_APP_KANSATSUKIROKUAPI
      },
      {
        name:'KansatsuKirokuSubdivApi',
        region: process.env.REACT_APP_KANSATSUKIROKUSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_KANSATSUKIROKUSUBDIVAPI
      },
      {
        name:'KansatsuKirokuObsrecApi',
        region: process.env.REACT_APP_KANSATSUKIROKUOBSRECAPIREGION,
        endpoint: process.env.REACT_APP_KANSATSUKIROKUOBSRECAPI
      },
      {
        name:'EndpointStatusApi',
        region: process.env.REACT_APP_ENDPOINTSTATUSAPIREGION,
        endpoint: process.env.REACT_APP_ENDPOINTSTATUSAPI
      },
      {
        name:'EndpointStatusSubdivApi',
        region: process.env.REACT_APP_ENDPOINTSTATUSSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_ENDPOINTSTATUSSUBDIVAPI
      },
      {
        name:'EndpointOperationApi',
        region: process.env.REACT_APP_ENDPOINTOPERATIONAPIREGION,
        endpoint: process.env.REACT_APP_ENDPOINTOPERATIONAPI
      },
      {
        name:'EndpointOperationSubdivApi',
        region: process.env.REACT_APP_ENDPOINTOPERATIONSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_ENDPOINTOPERATIONSUBDIVAPI
      },
      {
        name:'GetArchiveStatusApi',
        region: process.env.REACT_APP_GETARCHIVESTATUSAPIREGION,
        endpoint: process.env.REACT_APP_GETARCHIVESTATUSAPI
      },
      {
        name:'CreateArchiveApi',
        region: process.env.REACT_APP_CREATEARCHIVEAPIREGION,
        endpoint: process.env.REACT_APP_CREATEARCHIVEAPI
      },
      {
        name:'GetArchiveStatusSubdivApi',
        region: process.env.REACT_APP_GETARCHIVESTATUSAPISUBDIVREGION,
        endpoint: process.env.REACT_APP_GETARCHIVESTATUSSUBDIVAPI
      },
      {
        name:'GetArchiveStatusObsrecApi',
        region: process.env.REACT_APP_GETARCHIVESTATUSOBSRECAPIREGION,
        endpoint: process.env.REACT_APP_GETARCHIVESTATUSOBSRECAPI
      },
      {
        name:'CreateArchiveSubdivApi',
        region: process.env.REACT_APP_CREATEARCHIVESUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_CREATEARCHIVESUBDIVAPI
      },
      {
        name:'CreateArchiveObsrecApi',
        region: process.env.REACT_APP_CREATEARCHIVEOBSRECAPIREGION,
        endpoint: process.env.REACT_APP_CREATEARCHIVEOBSRECAPI
      },
      {
        name:'GetLatestKansatsuKirokuObsrecApi',
        region: process.env.REACT_APP_GETLATESTKANSATSUKIROKUOBSRECAPIREGION,
        endpoint: process.env.REACT_APP_GETLATESTKANSATSUKIROKUOBSRECAPI
      },
      {
        name:'GetKansatsuKirokuListObsrecApi',
        region: process.env.REACT_APP_GETKANSATSUKIROKULISTOBSRECAPIREGION,
        endpoint: process.env.REACT_APP_GETKANSATSUKIROKULISTOBSRECAPI
      },
      {
        name:'GetKansatsuKirokuListSubdivApi',
        region: process.env.REACT_APP_GETKANSATSUKIROKULISTSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_GETKANSATSUKIROKULISTSUBDIVAPI
      },
      {
        name:'GetLatestKansatsuKirokuSubdivApi',
        region: process.env.REACT_APP_GETLATESTKANSATSUKIROKUSUBDIVAPIREGION,
        endpoint: process.env.REACT_APP_GETLATESTKANSATSUKIROKUSUBDIVAPI
      }
    ]
  },
    Storage: {
        AWSS3: {
            bucket: process.env.REACT_APP_IMAGEUPLOADBUCKETNAME,
            region: process.env.REACT_APP_IMAGEUPLOADBUCKETREGION
        }
    }
};



// WEBPACK FOOTER //
// ./src/amplifyConfig.ts